<script setup lang="ts">
import { useRoute } from 'vue-router'
import PageBody from '../components/PageBody.vue'
import PageHeader from '../components/PageHeader.vue'
import { Button, EmptyState, Panel } from '../components/ui'
import { useTitle } from '../lib/hooks'

const route = useRoute()
useTitle('页面不存在')
</script>

<template>
  <PageHeader title="页面不存在" subtitle="链接可能已失效，或者路径拼错了" />
  <PageBody>
    <Panel>
      <EmptyState
        :title="`没有匹配的路径：${route.path}`"
        hint="后台的入口是侧栏里的四项：概览、账号与权益、剧集与字幕、审计日志。"
      >
        <template #action>
          <RouterLink to="/">
            <Button size="sm" variant="primary">回到概览</Button>
          </RouterLink>
        </template>
      </EmptyState>
    </Panel>
  </PageBody>
</template>
